<template>
  <div class="home-banner" :class="{ beike: hasBanner }">
    <div class="font-container" v-if="!hasBanner">
      <span class="name">{{ projectName }}</span>
      <span class="platform">成绩查询平台</span>
      <span class="company">- ATA，为梦想喝彩 -</span>
    </div>
    <img v-else class="beike_banner" :src="store.getters.banner" alt="" />
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
export default {
  name: "HomeBanner",
  setup() {
    const store = useStore();
    const projectName = computed(() => store.state.projectName);
    const hasBanner = computed(() => {
      return store.getters.banner;
    });
    return {
      projectName,
      hasBanner,
      store,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "scss/base.scss";
.home-banner {
  @include flex-center;
  width: 100%;
  height: 23%;
  background-image: url("../../../img/homebg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  &.beike {
    background-image: none;
    height: auto;
    .beike_banner {
      width: 100%;
      display: block;
    }
  }
  .font-container {
    display: flex;
    flex-direction: column;
    color: #fff;
    text-align: center;
    letter-spacing: 5px;
    .name {
      font-size: 40px;
      margin-bottom: 20px;
    }
    .platform {
      font-size: 60px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .company {
      font-size: 30px;
      opacity: 0.5;
    }
  }
}
</style>
